import { useTypedDispatch } from '@/store/hooks';
import { useMutation } from '@tanstack/react-query';
import { creatorActions } from '@/store/slices/creatorSlice';
import CreatorProductModuleApi from '@/api/CreatorProductModuleApi';

export function useAddCreatorProductModuleMutation() {
	const dispatch = useTypedDispatch();

	const addModuleMutation = useMutation({
		mutationFn: CreatorProductModuleApi.create,
		onSuccess: (creatorProductModule) => {
			dispatch(creatorActions.addCreatorProductModule(creatorProductModule));
		},
	});

	return addModuleMutation;
}
